import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  ftuOrderStepTitle: {
    description: 'Title for the orders step in the FTU wizard',
    defaultMessage: "First, let's import your orders.",
    id: '04NOL7',
  },
  ftuOrderStepDescription: {
    description: 'Description for the orders step in the FTU wizard',
    defaultMessage:
      'Connect one or more stores to automatically import orders. You can also add orders manually or <a>import via CSV</a> at any time.',
    id: 'oETw+g',
  },
  importInProgress: {
    description: 'Status text for when orders are being imported',
    defaultMessage: 'Import in progress',
    id: 'Z4uS0R',
  },
  importInfoMessage: {
    description: 'Information message about order import process',
    defaultMessage:
      "We'll let you know when your orders have finished importing. In the meantime, you can connect another store or continue to the next step.",
    id: 'DvWYbC',
  },
  connectAnotherStore: {
    description: 'Button text to connect another store',
    defaultMessage: '+ Connect another store',
    id: 'k/dNe4',
  },
  connectedStatus: {
    description: 'Status text for a connected store',
    defaultMessage: 'Connected',
    id: 'Xk1i9L',
  },
  importSuccessful: {
    description: 'Status text for when orders have been successfully imported',
    defaultMessage: 'Import successful',
    id: 'OBDR/F',
  },
  queuedStatus: {
    description: 'Status text for when a store import is queued',
    defaultMessage: 'Queued',
    id: '0aAOGl',
  },
  errorStatus: {
    description: 'Status text for when a store import has an error',
    defaultMessage: 'Error',
    id: 'kuKZJT',
  },
  unknownStatus: {
    description: 'Status text for when a store import status is unknown',
    defaultMessage: 'Unknown',
    id: 'vmKgvu',
  },
  storeErrorInfoMessage: {
    description: 'Info message displayed when there is an error importing orders from a store',
    defaultMessage: 'There was an error importing orders from this store. Please try again later.',
    id: '0oyna6',
  },
  selectImportMethod: {
    description: 'Placeholder text for the order import method dropdown',
    defaultMessage: 'Select an import method',
    id: '0IseX5',
  },
  connectOrderSource: {
    description: 'Dropdown option to connect an order source',
    defaultMessage: 'Connect an order source',
    id: '4Y15T9',
  },
  uploadCSV: {
    description: 'Dropdown option to upload a CSV file',
    defaultMessage: 'Upload a CSV',
    id: 'dRKKVO',
  },
  noOrdersYet: {
    description: "Dropdown option for users who don't have orders yet",
    defaultMessage: "I don't have orders yet",
    id: 'skYTqF',
  },
  uploadYourOrders: {
    description: 'Header text for the upload orders section',
    defaultMessage: 'Upload your orders',
    id: '17tZPF',
  },
  selectFile: {
    description: 'Button text to select and process the uploaded CSV file',
    defaultMessage: 'Select a file',
    id: '5FECEw',
  },
  createNewManualStore: {
    description: 'Dropdown option to create a new manual store',
    defaultMessage: 'Create new manual store',
    id: 'rO7J6V',
  },
  noOrdersYetTitle: {
    description: 'Title for the no orders yet component',
    defaultMessage: 'No orders or store to connect yet, no problem!',
    id: 'EiwvTb',
  },
  noOrdersYetDescription: {
    description: 'Description for the no orders yet component',
    defaultMessage: "Create and manage orders by hand whenever you need. It's quick, simple, and gives you full control.",
    id: 'Ofy1xW',
  },
  learnMore: {
    description: 'Link text to learn more',
    defaultMessage: 'Learn more',
    id: 'QLVGz7',
  },
  addManualOrder: {
    description: 'Button text to add a manual order',
    defaultMessage: 'Add a Manual Order',
    id: 'm7Nhmi',
  },
  ordersIllustrationAlt: {
    description: 'Alt text for the orders illustration',
    defaultMessage: 'Orders illustration',
    id: 'hJDVOr',
  },
  uploadFileStepText: {
    description: 'Step title for upload file step',
    defaultMessage: 'Upload File',
    id: 'PMp+Vr',
  },
  matchFieldsStepText: {
    description: 'Step title for match fields step',
    defaultMessage: 'Match Fields',
    id: 'upg0r7',
  },
  importProcessingStepText: {
    description: 'Step title for import processing step',
    defaultMessage: 'Import Orders',
    id: 'MSios9',
  },
  importProcessingTitle: {
    description: 'Title shown during import processing',
    defaultMessage: 'Importing your orders',
    id: 'E+eqO4',
  },
  importSuccessMessage: {
    description: 'Message shown when import succeeds',
    defaultMessage: 'Your orders have been imported successfully',
    id: 'nZ5uDa',
  },
  importSuccessfulBanner: {
    description: 'Banner message shown when CSV file is successfully imported',
    defaultMessage: 'While we finish importing your orders, feel free to move on to the next step.',
    id: 'P2P5Bw',
  },
  viewOrders: {
    description: 'Link text to view orders',
    defaultMessage: 'View Orders',
    id: 'HAwIt1',
  },
  importAnotherFile: {
    description: 'Link text to import another CSV file',
    defaultMessage: 'Import another file',
    id: 'nJ025z',
  },
});
